module.exports = __webpack_public_path__ + "img/poster-ru20x10.fc0e7156.jpg";